// Testimonials: same showreel card nodes presented two ways at the 768px
// breakpoint — a CSS marquee on desktop, a Swiper slider on mobile.

const MOBILE_MQ = '(max-width: 768px)';

function buildStaticRow(row, cards) {
  row.replaceChildren();

  const wrap = document.createElement('div');
  wrap.className = 'section-testimonials__cards';
  cards.forEach((c) => wrap.appendChild(c));

  row.appendChild(wrap);
}

function buildSwiper(row, cards, peek) {
  row.classList.remove('is-marquee');
  row.classList.toggle('is-peek', peek);
  row.replaceChildren();

  const sliderEl = document.createElement('div');
  sliderEl.className = 'section-testimonials__swiper swiper';

  const wrapper = document.createElement('div');
  wrapper.className = 'swiper-wrapper';

  cards.forEach((c) => {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide';
    slide.appendChild(c);
    wrapper.appendChild(slide);
  });
  sliderEl.appendChild(wrapper);
  row.appendChild(sliderEl);

  // Pagination lives OUTSIDE the .swiper (which has overflow:hidden) so the
  // dots render below the card rather than being clipped.
  const pagination = document.createElement('div');
  pagination.className = 'swiper-pagination';
  row.appendChild(pagination);

  if (!window.Swiper) return null;

  return new window.Swiper(sliderEl, {
    slidesPerView: peek ? 1.12 : 1,
    spaceBetween: 16,
    grabCursor: true,
    pagination: { el: pagination, clickable: true },
    // Dots only — no navigation arrows.
  });
}

export default function initTestimonials() {
  const section = document.querySelector('.section-testimonials');
  if (!section) return;

  const row = section.querySelector('.section-testimonials__row');
  if (!row) return;

  // Pages may wrap each card in a caption wrapper; fall back to bare cards.
  const wrapped = row.querySelectorAll('.section-testimonials__item');
  const cards = Array.from(wrapped.length ? wrapped : row.querySelectorAll('.showreel'));
  if (!cards.length) return;

  // Detach the editor wrappers; the card nodes live on in `cards`.
  row.replaceChildren();

  const mq = window.matchMedia(MOBILE_MQ);
  let swiper = null;
  let mode = null;

  function apply() {
    const next = mq.matches ? 'mobile' : 'desktop';
    if (next === mode) return;
    mode = next;

    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }

    if (next === 'mobile') {
      swiper = buildSwiper(row, cards, wrapped.length > 0);
    } else {
      buildStaticRow(row, cards);
    }
  }

  apply();
  mq.addEventListener('change', apply);
}
